import { useEffect } from 'react';
import { Skeleton, Row, Col, Card } from 'antd';
import Layout from '../components/layout/Layout';
import { useDispatch, useSelector } from 'react-redux';
import ContactForm from '../components/contact/ContactForm';
import { fetchContactContent, selectContactData, selectContactStatus } from '../redux/contactSlice';

const ContactPage = () => {
  const dispatch = useDispatch();
  const content = useSelector(selectContactData);
  const status = useSelector(selectContactStatus);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchContactContent());
    }
  }, [status, dispatch]);

  const handleSuccess = () => {
    dispatch(fetchContactContent());
  };

  if (status === 'loading' && !content) {
    return (
      <Layout title="Contact Information">
        <Row gutter={[20, 24]}>
          <Col xs={24}>
            <Card style={{ borderRadius: '12px' }}>
              <Skeleton active paragraph={{ rows: 6 }} />
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card style={{ borderRadius: '12px' }}>
              <Skeleton active paragraph={{ rows: 4 }} />
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card style={{ borderRadius: '12px' }}>
              <Skeleton active paragraph={{ rows: 4 }} />
            </Card>
          </Col>
        </Row>
      </Layout>
    );
  }

  return (
    <Layout title="Contact Information">
      <ContactForm
        initialValues={content}
        onSuccess={handleSuccess}
      />
    </Layout>
  );
};

export default ContactPage;
